let audioContext: AudioContext | null = null;

const getAudioContext = (): AudioContext | null => {
    if (audioContext === null && typeof window.AudioContext === 'function') {
        audioContext = new window.AudioContext();
    }

    return audioContext;
};

/**
 * Resumes the shared audio context. Browsers (iOS Safari above all) keep it suspended until a
 * user gesture, so call this from a click handler before the first beep is needed.
 */
export const unlockBeep = (): void => {
    void getAudioContext()?.resume();
};

/**
 * A short scanner-like beep synthesised with Web Audio, so no sound asset has to be shipped.
 */
export const beep = (frequency = 1800, durationMs = 90): void => {
    const context = getAudioContext();

    if (context === null) {
        return;
    }

    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const end = context.currentTime + durationMs / 1000;

    oscillator.type = 'square';
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.15, context.currentTime);

    // Fades out instead of cutting off, which would click.
    gain.gain.exponentialRampToValueAtTime(0.001, end);

    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start();
    oscillator.stop(end);
};
